export default __webpack_public_path__ + "static/media/rambouillet17.6199ffe5.jpg";